import { render, staticRenderFns } from "./StoperPrices.vue?vue&type=template&id=23b4a109&scoped=true&"
import script from "./StoperPrices.vue?vue&type=script&lang=js&"
export * from "./StoperPrices.vue?vue&type=script&lang=js&"
import style0 from "./StoperPrices.vue?vue&type=style&index=0&id=23b4a109&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4a109",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b4a109')) {
      api.createRecord('23b4a109', component.options)
    } else {
      api.reload('23b4a109', component.options)
    }
    module.hot.accept("./StoperPrices.vue?vue&type=template&id=23b4a109&scoped=true&", function () {
      api.rerender('23b4a109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StoperPrices.vue"
export default component.exports